module.exports = __webpack_public_path__ + "assets/img/video-btn-1501b3cb.png";